import RegistrationFieldsDropdown from './RegistrationFieldsDropdown';

export default RegistrationFieldsDropdown;
